import {useState} from 'react';
import type {GridSortModel} from '@mui/x-data-grid';
import {getOrdering} from '../utils';
import {DEFAULT_PAGE, DEFAULT_PAGE_SIZE} from '../constants';

interface UsePaginationStateProps {
  defaultSortModel: GridSortModel;
}

interface UsePaginationStateResult {
  page: number;
  setPage: (newPage: number) => void;
  pageSize: number;
  onPageSizeChange: (newPageSize: number) => void;
  ordering: string;
  onSortModelChange: (newSortModel: GridSortModel) => void;
}

export const usePaginationState = ({
  defaultSortModel,
}: UsePaginationStateProps): UsePaginationStateResult => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [ordering, setOrdering] = useState(getOrdering(defaultSortModel));

  const onSortModelChange = (sortModel: GridSortModel) => {
    const newOrdering = getOrdering(
      sortModel.length ? sortModel : defaultSortModel,
    );
    setOrdering(newOrdering);
    setPage(DEFAULT_PAGE);
  };

  const onPageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(DEFAULT_PAGE);
  };

  return {
    page,
    setPage,
    pageSize,
    onPageSizeChange,
    ordering,
    onSortModelChange,
  };
};
